var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDnsProtectionImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#007da0;}.g{fill:#0fb4d1;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.217 -1106.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M141.783,1061.606a14.842,14.842,0,0,1,29.511-2.22,11.718,11.718,0,0,1,.154,2.454,1.084,1.084,0,0,0,.751,1.268c1.958.669,2.467,2.047,2.259,4a37.247,37.247,0,0,0-.023,4.849,3.277,3.277,0,0,1-.767,2.277,23.57,23.57,0,0,1-6.616,5.077,1.335,1.335,0,0,1-1.122-.168c-1.444-.942-2.831-1.971-4.271-2.92a1.521,1.521,0,0,0-1.077-.225,14.887,14.887,0,0,1-18.718-12.753C141.8,1062.705,141.808,1062.153,141.783,1061.606Zm30.825,7.518c0-.986-.026-1.973.011-2.958a1.035,1.035,0,0,0-.569-1.046c-1.644-1.034-3.263-2.108-4.864-3.207a.728.728,0,0,0-1-.011c-1.624,1.114-3.265,2.2-4.932,3.253a.987.987,0,0,0-.523.984c.02,1.89.035,3.781-.006,5.67a1.92,1.92,0,0,0,.668,1.679q2.448,1.927,4.943,3.792a.69.69,0,0,0,.643,0q2.5-1.855,4.961-3.768a1.844,1.844,0,0,0,.677-1.673C172.569,1070.934,172.608,1070.028,172.608,1069.124Zm-22.294-8.421h5.348v-5.424H151.12Zm5.373,1.935h-5.375l.816,5.4h4.559Zm1.9-7.365v5.418h5.368l-.836-5.418Zm-9.1,5.458.743-5.488c-1.21,0-2.411-.009-3.613.011a.618.618,0,0,0-.461.242,12.2,12.2,0,0,0-1.506,5.235Zm-4.845,1.9a12.4,12.4,0,0,0,1.5,5.177.611.611,0,0,0,.451.257c1.219.021,2.439.011,3.636.011l-.736-5.445Zm26-1.693a13.023,13.023,0,0,0-1.534-5.414.614.614,0,0,0-.445-.269c-1.221-.022-2.442-.012-3.641-.012l.742,5.44c.2-.138.338-.223.465-.324,1.441-1.143,1.377-1.181,2.914,0A6.288,6.288,0,0,0,169.649,1060.939Zm-17.812,8.979c.865,1.955,1.781,3.7,3.831,4.645v-4.645Zm3.861-21.158c-2.092.974-3.005,2.711-3.831,4.617H155.7Zm1.89,4.613h3.83c-.867-1.884-1.735-3.669-3.83-4.59Zm1.34,14.666c0-.885.051-1.68-.014-2.466a1.555,1.555,0,0,1,1-1.752,18.919,18.919,0,0,0,1.787-1.037l-.068-.138H157.6v5.393Zm-7.219,5.679c-.587-1.208-1.114-2.314-1.666-3.409-.084-.167-.275-.391-.424-.4-.968-.036-1.938-.019-3.08-.019A13.058,13.058,0,0,0,151.708,1073.719Zm-5.173-20.287c1.127,0,2.052.016,2.975-.014a.672.672,0,0,0,.492-.3c.572-1.133,1.11-2.284,1.687-3.489A12.96,12.96,0,0,0,146.536,1053.431Zm15.026-3.828c.588,1.219,1.122,2.35,1.684,3.465a.679.679,0,0,0,.459.346c.945.032,1.891.016,3.013.016A13.017,13.017,0,0,0,161.562,1049.6Zm-2.729,20.358h-1.207v4.484l.209.14c.427-.408,1.177-.788,1.217-1.231A20.157,20.157,0,0,0,158.833,1069.961Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M270.377,1169.88l3.166-3.192c.174-.175.342-.357.529-.516a.839.839,0,0,1,1.249.015.815.815,0,0,1,.019,1.246q-2.128,2.171-4.3,4.3a.832.832,0,0,1-1.252.026c-.833-.792-1.643-1.61-2.443-2.436a.826.826,0,0,1-.021-1.249.843.843,0,0,1,1.308,0C269.2,1168.629,269.737,1169.213,270.377,1169.88Z",
    transform: "translate(-104.657 -99.485)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnsProtectionImage);
export default __webpack_public_path__ + "static/media/dnsProtectionImage.32baf7c85d6ad132d6782197e190623d.svg";
export { ForwardRef as ReactComponent };